export const EMPTY_WALLET = 'address-card';
export const ERROR_OCCURRED = 'exclamation-circle';
